<!--
 * @Autor:
 * @Date: 2025-09-17 16:25:33
 * @LastEditTime: 2025-09-17 19:42:32
 * @Description:
 * @FilePath: \xxci\register\src\components\index.vue
-->
<template>
  <div class="reg-container tlgl">
    <div id="cyou_top">
      <div id="cyou_top_main">
        <div class="cyou_top_logo"><a style="width:120px;background-position:0 0;" href="javascript:void(0)"
            title="畅游"></a></div>
        <ul class="cyou_top_nav">
          <li class="cyou_top_nav_li cyou_top_nav_li_logined">欢迎您：<span id="cyou_top_username"></span> <a
              href="javascript:void(0)">退出</a></li>
          <li class="cyou_top_nav_li"> <a href="javascript:void(0)"> <span
                class="cyou_top_li_icon cyou_top_login_icon"></span>登录</a> </li>
          <li class="cyou_top_nav_li"> <a @click="handleRouter($event, 'register')">
              <span class="cyou_top_li_icon cyou_top_reg_icon"></span>注册</a> </li>
          <li class="cyou_top_nav_li"> <a href="javascript:void(0)"> <span
                class="cyou_top_li_icon cyou_top_gm_icon"></span>客服</a> </li>
        </ul>
      </div>
    </div>
    <div id="header">
      <h1>畅游通行证</h1>
      <ul id="nav" class="clearfix">
        <li><a href="javascript:void(0)"><span>我的通行证</span></a></li>
        <li><a href="javascript:void(0)"><span>购卡充值</span></a></li>
        <li style="background-color: #c40808;"><a @click="handleRouter($event, 'update')"><span>密码修改</span></a></li>
        <li><a href="javascript:void(0)"><span>客服中心</span></a></li>
        <li><a href="javascript:void(0)"><span style="color:#FFD800">畅游+</span></a></li>
      </ul>
    </div>
    <router-view />
    <div id="footer"></div>
    <div id="cyou_bottom">
      <div id="cyou_bottom_main">
        <div class="cyou_bottom_logo"><a title="畅游" href="javascript:void(0)"></a></div>
        <div class="cyou_bottom_sprite"><a class="beian" title="经营性网站备案信息" href="javascript:void(0)"></a><a
            class="stamp" title="电子图章" href="javascript:void(0)"></a>
        </div>
        <div class="cyou_bottom_cont">
          <p class="links"><a href="javascript:void(0)">关于畅游</a> | <a href="javascript:void(0)">法律声明</a> | <a
              href="javascript:void(0)">联系我们</a> | <a href="javascript:void(0)">诚聘英才</a> | <a
              href="javascript:void(0)">畅游品牌战略联盟</a> | <a href="javascript:void(0)">投资者关系</a></p>
          <p>北京畅游时代数码技术有限公司版权所有 COPYRIGHT © 2014 CHANGYOU.COM LIMITED. ALL RIGHTS RESERVED.</p>
          <p><a href="javascript:void(0)">京网文[2014]0949-249号</a> |
            京ICP证：070525号 ISBN号978-7-89989-782-9 | 京公网安备110107000007</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/index.css';
export default {
  methods: {
    handleRouter(event, path) {
      event.stopPropagation = true;
      const inputStr = location.href.split('?')[1]
      this.$router.push(`${path}?${inputStr || ''}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue